const initNewsletterFormPdp = (root = document) => {
  const dialog = root.querySelector('[data-newsletter-modal]');
  if (!dialog || dialog.dataset.newsletterInit === 'true') return;
  dialog.dataset.newsletterInit = 'true';

  const formView = dialog.querySelector('[data-newsletter-form]');
  const successView = dialog.querySelector('[data-newsletter-success]');
  const submitButton = dialog.querySelector('[data-newsletter-submit]');
  const copyButton = dialog.querySelector('[data-newsletter-copy]');
  const couponEl = dialog.querySelector('[data-newsletter-coupon]');
  const titleEl = dialog.querySelector('[data-newsletter-title]');

  const open = () => {
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', 'open');
    }
  };

  const close = () => {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  };

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) close();
  });

  dialog.querySelectorAll('[data-newsletter-close]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      close();
    });
  });

  // Botão bloqueado até checkbox ser marcado
  const checkbox = dialog.querySelector('[name="newsletter_privacy"]');
  if (submitButton instanceof HTMLButtonElement) {
    submitButton.disabled = true;
  }
  checkbox?.addEventListener('change', () => {
    if (submitButton instanceof HTMLButtonElement) {
      submitButton.disabled = !checkbox.checked;
    }
  });

  formView?.addEventListener('submit', (e) => {
    e.preventDefault();

    const nomeInput = dialog.querySelector('[name="newsletter_name"]');
    const emailInput = dialog.querySelector('[name="newsletter_email"]');
    const nome = nomeInput?.value?.trim() || '';
    const email = emailInput?.value?.trim() || '';

    // Validação extra (o browser já valida required + checkbox)
    if (!nome || !email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;

    // Envia para Google Sheets via App Proxy
    var params = new URLSearchParams(window.location.search);
    var data = {
      nome: nome,
      email: email,
      origem: 'newsletter',
      page_url: window.location.href,
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_term: params.get('utm_term') || '',
      utm_content: params.get('utm_content') || ''
    };

    navigator.sendBeacon(
      '/apps/hub-proxy/api/form-submit',
      new Blob([JSON.stringify(data)], { type: 'application/json' })
    );

    // Mostra tela de sucesso
    if (formView instanceof HTMLElement && successView instanceof HTMLElement) {
      formView.classList.add('is-hidden');
      successView.classList.remove('is-hidden');
      if (titleEl instanceof HTMLElement) {
        var successHeading = dialog.dataset.successHeading || '';
        if (successHeading) titleEl.textContent = successHeading;
      }
    }
  });

  copyButton?.addEventListener('click', async () => {
    const code = couponEl?.textContent?.trim() || '';
    if (!code) return;

    try {
      await navigator.clipboard.writeText(code);
    } catch {
      const textarea = document.createElement('textarea');
      textarea.value = code;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      textarea.remove();
    }
  });

  // Abre o popup ao clicar em links com href="#ganheoff"
  document.querySelectorAll('a[href="#ganheoff"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      open();
    });
  });

  window.openNewsletterFormPdp = open;
  window.closeNewsletterFormPdp = close;
};

document.addEventListener('DOMContentLoaded', () => initNewsletterFormPdp());
document.addEventListener('shopify:section:load', (event) => initNewsletterFormPdp(event.target));
